/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Controller } from 'react-hook-form';

import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';

import DatePickerComponent from './DatePickerComponent';

import styles from './DatePickerComponent.module.scss';

const DateInput = ({
  errors,
  register,
  dirtyFields,
  placeholder,
  defaultProps,
  readOnly,
  name,
  label,
  hideLabel,
  className,
  defaultValue,
  iconOnPrefix,
  highlightDates,
  reoccurView,
  mustBeInTheFuture,
  minDate,
  maxDate,
  inline,
  onSelect,
  editingMode,
  appearance,
  inputRef,
  control,
  fullWidth,
  ...rest
}) => {
  const icon = { iconName: 'Calendar' };
  const containerClasses = classnames(styles.dateInput, {
    [styles['full-width']]: fullWidth
  });

  return (
    <div className={containerClasses}>
      {label && !hideLabel && <label className={styles.label}>{label}</label>}
      <Controller
        as={<DatePickerComponent />}
        name={name}
        control={control}
        defaultValue={defaultValue}
        mustBeInTheFuture={mustBeInTheFuture}
        minDate={minDate}
        maxDate={maxDate}
        prefixIcon={iconOnPrefix && icon}
        suffixIcon={!iconOnPrefix && icon}
        className={className}
        readOnly={readOnly}
        editingMode={editingMode}
        reoccurView={reoccurView}
        onSelect={onSelect}
        highlightDates={highlightDates}
        hideLabel={hideLabel}
        inline={inline}
        {...rest}
      />
    </div>
  );
};

DateInput.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  dirtyFields: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  defaultProps: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  hideLabel: PropTypes.bool,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  readOnly: PropTypes.bool,
  iconOnPrefix: PropTypes.bool,
  mustBeInTheFuture: PropTypes.bool,
  appearance: PropTypes.oneOf(['default', 'search', 'form']),
  inputRef: PropTypes.shape({}),
  control: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool
};

DateInput.defaultProps = {
  placeholder: null,
  defaultProps: null,
  label: 'Date',
  name: 'date',
  hideLabel: false,
  className: '',
  defaultValue: moment(new Date()).format('YYYY-MM-DD'),
  readOnly: false,
  iconOnPrefix: false,
  mustBeInTheFuture: false,
  appearance: 'default',
  inputRef: null,
  fullWidth: false
};

export default DateInput;
